import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { portalLogin } from '../api/client';

export default function ClientLogin() {
    const navigate = useNavigate();
    const [accessCode, setAccessCode] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleLogin = async () => {
        if (!accessCode.trim()) { setError('Please enter your access code or username.'); return; }
        if (!password.trim()) { setError('Please enter your password.'); return; }
        setSubmitting(true);
        setError('');
        try {
            const data = await portalLogin({ access_code: accessCode.trim().toUpperCase(), password });
            if (data.detail) {
                setError(data.detail === 'Invalid password' ? 'Incorrect password.' :
                    data.detail === 'Invalid access code' ? 'Access code not found.' :
                        data.detail === 'Portal not set up yet' ? 'Please use your invite link to set up your account first.' :
                            data.detail);
                return;
            }
            localStorage.setItem('portal_client_id', data.client_id);
            localStorage.setItem('portal_access_code', data.access_code);
            localStorage.setItem('portal_client_name', data.client_name);
            localStorage.setItem('portal_token', data.token);
            navigate(`/portal/${data.access_code}/home`);
        } catch (err) {
            setError('Something went wrong. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div style={styles.screen}>
            <div style={styles.card}>
                <div style={styles.logo}>Transformation Companion</div>
                <div style={styles.title}>Client portal</div>
                <div style={styles.subtitle}>Sign in to your coaching portal</div>

                {error && <div style={styles.errorAlert}>{error}</div>}

                <div style={styles.formGroup}>
                    <label style={styles.label}>Access code or username</label>
                    <input
                        style={styles.input}
                        placeholder="Enter your access code or username"
                        value={accessCode}
                        onChange={e => setAccessCode(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleLogin()}
                    />
                    <div style={styles.hint}>Your coach will have given you an access code — or use the username you chose</div>
                </div>

                <div style={styles.formGroup}>
                    <label style={styles.label}>Password</label>
                    <input
                        type="password"
                        style={styles.input}
                        placeholder="Enter your password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleLogin()}
                    />
                </div>

                <button
                    style={{ ...styles.btn, opacity: submitting ? 0.7 : 1 }}
                    onClick={handleLogin}
                    disabled={submitting}
                >
                    {submitting ? 'Signing in...' : 'Sign in'}
                </button>

                <div style={styles.divider}>
                    <span style={styles.dividerText}>First time here?</span>
                </div>

                <div style={styles.setupNote}>
                    Use the invite link your coach sent you to set up your account.
                </div>

                <p style={styles.coachFooter}>
                    Are you a coach?{' '}
                    <Link to="/login" style={styles.coachLink}>Log in here</Link>
                </p>
            </div>
        </div>
    );
}

const styles = {
    screen: { minHeight: '100vh', background: '#F8F5F0', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontFamily: "'Figtree','Segoe UI',sans-serif" },
    card: { background: 'white', borderRadius: '16px', border: '1px solid #D8E0DC', padding: '40px', width: '100%', maxWidth: '420px', boxShadow: '0 8px 32px rgba(0,0,0,0.08)' },
    logo: { fontFamily: 'Georgia,serif', fontSize: '20px', fontWeight: '300', fontStyle: 'italic', color: '#5C7A6B', marginBottom: '24px', textAlign: 'center' },
    title: { fontFamily: 'Georgia,serif', fontSize: '26px', fontWeight: '300', color: '#2D3A35', marginBottom: '8px', textAlign: 'center' },
    subtitle: { fontSize: '14px', color: '#8C9E98', marginBottom: '28px', textAlign: 'center', lineHeight: 1.6 },
    formGroup: { marginBottom: '16px' },
    label: { display: 'block', fontSize: '12px', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.07em', color: '#8C9E98', marginBottom: '8px' },
    input: { width: '100%', padding: '12px 14px', borderRadius: '8px', border: '1px solid #D8E0DC', background: '#F8F5F0', fontFamily: "'Figtree',sans-serif", fontSize: '16px', color: '#2D3A35', outline: 'none', boxSizing: 'border-box' },
    hint: { fontSize: '12px', color: '#8C9E98', marginTop: '6px' },
    btn: { width: '100%', padding: '13px', borderRadius: '8px', background: '#5C7A6B', border: 'none', color: 'white', fontFamily: "'Figtree',sans-serif", fontSize: '15px', fontWeight: '500', cursor: 'pointer', marginTop: '8px' },
    errorAlert: { background: '#F5EAEA', color: '#B85C5C', padding: '12px 14px', borderRadius: '8px', fontSize: '13.5px', marginBottom: '16px' },
    divider: { textAlign: 'center', margin: '24px 0 16px', borderTop: '1px solid #D8E0DC', paddingTop: '20px' },
    dividerText: { fontSize: '13px', color: '#8C9E98' },
    setupNote: { fontSize: '13px', color: '#8C9E98', textAlign: 'center', lineHeight: 1.6, background: '#F8F5F0', borderRadius: '8px', padding: '12px' },
    coachFooter: { textAlign: 'center', fontSize: '13.5px', color: '#8C9E98', marginTop: '16px' },
    coachLink: { color: '#5C7A6B', textDecoration: 'none', fontWeight: '500' },
};